module.exports = __webpack_public_path__ + "static/media/largeShield.be4f2e24.svg";